import QueryString from "qs"
import http from "../index"
import {apiCountries,
    apiCreateSimSuggested, 
    apiExportExcelTemplate,
    apiGetWarehouseIn, 
    apiListCarrier, 
    apiListProvider, 
    apiListData,
    apiCreateData,
    apiDeleteData,
    apiCreateOrder,
    apiListWarehouseOrder,
    apiWarehouseInDetail,
    apiGetStock,
    apiImportExcelTemplate,
    apiSimWarehouse,
    apiSimSuggestedDetail,
    apiUpdateSimSuggested,
    apiDetailOrder,
    apiExportWarehouse,
    apiUpdateOrder,
    apiExportSimSuggested,
    apiExportData,
    apiExportWareHouseData,
    apiExportOutOfStock,
    apiExportWareHouseDataLeader,
    apiExportWareHouseAppovalData,
    apiGetWarehouseWarning,
    apiDeleteWarehouse,
    apiGetHistoryUpdateSim
} from "./urls"
const exportData = (params) => http.get(apiExportData, {responseType: "blob",params: params });
const exportWareHouseData = (params) => http.get(apiExportWareHouseData, { params, responseType: "blob"});
const exportWareHouseAppovalData = (params) => http.get(apiExportWareHouseAppovalData, { params, responseType: "blob"});
const listWarehouseIn = params => http.get(apiGetWarehouseIn, {params} ) 
const CreateSimSuggested = body => http.post(apiCreateSimSuggested, body)
const exportExcelSimSuggested = body => http.post(apiExportSimSuggested, body, { responseType: 'blob' })

const warehouseDetail = id => http.get(`/1.0/wsm/warehouse/${id}/detail`)
const warehouseUpdate = (id, body) => http.put(`1.0/wsm/warehouse/${id}/update`, body)
const getListProvider = () => http.get(apiListProvider)
const getListCarrier = () => http.get(apiListCarrier)
const getWarehouseExcelTemplate = () => http.get(apiExportExcelTemplate, {responseType: "blob"})
const postWarehouseExcelTemplate = (body) => http.post(apiImportExcelTemplate, body)

const listData = params => http.get(apiListData, { params })
const createData = body => http.post(apiCreateData, body)
const updateData = (id, body) => http.put(`1.0/wsm/data/${id}/update`, body)
const getDetailData = (id) => http.get(`/1.0/wsm/data/${id}/detail`)
const deleteData = (params)=> http.delete(apiDeleteData, { params });
const updateDataBrowse = (id, body) => http.put(`1.0/wsm/data/${id}/browse`, body)
const updateDataRefuse= (id, body) => http.put(`1.0/wsm/data/${id}/refuse`, body)
const createOrder = body => http.post(apiCreateOrder, body)
const listOrder = params => http.get(apiListWarehouseOrder, { params })
const getStockQuantity = params => http.get(apiGetStock, {params})
const getListSimWarehouse = params => http.get(apiSimWarehouse, {params})
const DetailListSimSuggested = params => http.post(apiSimSuggestedDetail, params)
const updateListSimSuggested = (id, body) => http.put(apiUpdateSimSuggested(id), body)
const detailOrder = id => http.get(apiDetailOrder(id))
const updateOrder = (id,body) => http.put(apiUpdateOrder(id), body)
const updatePriceSim = (id, body) => http.put(`1.0/wsm/buy/sim/${id}/update`, body)
// ExportWarehouse
const getExportWarehouse = params => http.get(apiExportWarehouse, {params})
const getDetailExportWarehouse  = (id) => http.get(`/1.0/wsm/export/warehouse/${id}/detail`)
const updateExportWarehouse = (id, body) => http.put(`/1.0/wsm/export/warehouse/${id}/update`, body)
const updateStatusBrowse = (id, body) => http.put(`/1.0/wsm/export/warehouse/${id}/browse`, body)
const updateStatusRefuse = (id, body) => http.put(`/1.0/wsm/export/warehouse/${id}/refuse`, body)
const getExportOutOfStock = (params) => http.get(apiExportOutOfStock, {params, responseType: "blob"})
const listDataLeader = params => http.get(apiExportWareHouseDataLeader, { params })
const listWarehouseWarning = params => http.get(apiGetWarehouseWarning, {params} ) 
const deleteWarehouse = ids => http.delete(apiDeleteWarehouse, { data: { ids } });
const getHistoryUpdateSim = (id) => http.get(apiGetHistoryUpdateSim(id))
const WarehouseService = {
    listWarehouseIn,
    warehouseDetail,
    CreateSimSuggested,
    exportExcelSimSuggested,
    listDataLeader,
    warehouseUpdate,        
    getListProvider,
    getListCarrier,
    getWarehouseExcelTemplate,
    listData,
    createData,
    updateData,
    deleteData,
    getDetailData,
    updateDataBrowse,
    updateDataRefuse,
    createOrder,
    listOrder,
    getStockQuantity,
    getListSimWarehouse,
    postWarehouseExcelTemplate,
    DetailListSimSuggested,
    updateListSimSuggested,
    detailOrder,
    getExportWarehouse,
    getDetailExportWarehouse,
    updateStatusBrowse,
    updateStatusRefuse,
    updateOrder,
    exportData,
    exportWareHouseData,
    getExportOutOfStock,
    updateExportWarehouse,
    updatePriceSim,
    exportWareHouseAppovalData,
    listWarehouseWarning,
    deleteWarehouse,
    getHistoryUpdateSim
}
export default WarehouseService